import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import { SHOPIFY_URL } from "../../utils/shopify.utils";
import ContainedButton from "../../components/Buttons/ContainedButton";
import dots_green from "../../assets/images/Group 4841.png";
import mattress_photo from "../../assets/images/mattress/Layer 0.png";

const BuildYourBedColumn2 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div
      className="col-9 desktop-only"
      style={{
        marginTop: "-13vh",
        position: "absolute",
        marginLeft: "32vh",
        width: "60%"
      }}
    >
      <div
        style={{
          width: "100%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: 60,
          fontFamily: "elena-web-basic",
          marginTop: "5vh",
          fontWeight: "bold",
        }}
      >
        {t("every evrbed starts with an evrbase")}
      </div>
      <div
        style={{
          width: "65%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: 25,
          textAlign: "center",
          fontFamily: "noto-sans",
        }}
      >
        {t("Build Your Perfect Sleep In 5 Minutes")}
      </div>
      <div
        style={{
          width: "64.5%",
          color: theme.COLORS.BLUE.darkBlueGreen,
          fontSize: 18,
          marginTop: 10,
          paddingLeft: 110,
          paddingRight: 110,
          textAlign: "center",
          fontFamily: "noto-sans",
        }}
      >
        {t(
          "Every evrbase includes exceptionally balanced support by utilizing North American made Pocketed Coils with Firm Edge Support. The replaceable zippered Cooling Knitted TENCEL fabric is Semi--Plush Quilted, and is made in Montreal. Talalay Latex is the best material to sleep on for feel, durability and temperature regulation. These layers come in a variety of firmness options and await your personalization."
        )}
      </div>
      <div
        className="row"
        style={{
          marginLeft: 210,
          marginTop: "3vh",
        }}
      >
        <Link
          to={"/why-evrbed"}
          style={{
            color: theme.COLORS.WHITE.backgroundWhite,
            textDecoration: "none",
            width: "auto",
            position: "relative",
            zIndex: 1000,
          }}
        >
          <ContainedButton
            className="col-auto"
            color={theme.COLORS.BLUE.backgroundBlue}
            fontColor={theme.COLORS.BLUE.blueGreen}
            variant="outlined"
            styles={{ width: "12vw" }}
            onClick={() =>
              (window.top.location.href = SHOPIFY_URL + "products/evrbed")
            }
          >
            {t("VIEW EVRBASE DETAILS")}
          </ContainedButton>
        </Link>
        <Link
          to={"/mattress-builder"}
          style={{
            color: theme.COLORS.WHITE.backgroundWhite,
            textDecoration: "none",
            width: "auto",
            position: "relative",
            zIndex: 1000,
          }}
        >
          <ContainedButton
            className="col-auto"
            styles={{ width: "10vw" }}
            onClick={() => {
              return (window.top.location.href =
                SHOPIFY_URL + "pages/mattress-builder");
            }}
          >
            {t("START BUILDING")}
          </ContainedButton>
        </Link>
      </div>
      <div style={{ marginLeft: "-29vw", marginTop: "35vh" }}>
        <div
          style={{
            borderRadius: "0px 60px 0px 60px",
            width: 173,
            height: 195,
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: theme.COLORS.GREEN.green,
            marginTop: "-35px",
            marginLeft: "380px",
            opacity: 0.25,
          }}
        />
        <div
          style={{
            background: "#ABE1FA",
            borderRadius: "50px 0px 50px 0px",
            marginLeft: "480px",
            marginTop: "-102px",
            width: "330px",
            height: "140px",
            opacity: 0.35,
            zIndex: 100,
            boxShadow: "4px 4px 0px #005DFF0F",
          }}
        ></div>
      </div>
      <div style={{ marginLeft: "17vw", marginTop: "-93vh" }}>
        <div
          style={{
            borderRadius: "0px 60px 0px 60px",
            width: 173,
            height: 200,
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: theme.COLORS.GREEN.green,
            marginTop: "-35px",
            marginLeft: "380px",
            opacity: 0.25,
          }}
        />
        <div
          style={{
            background: "#ABE1FA",
            borderRadius: "100px 0px 100px 0px",
            marginLeft: "480px",
            marginTop: "-95px",
            width: "350px",
            height: "250px",
            opacity: 0.35,
            zIndex: 100,
            boxShadow: "4px 4px 0px #005DFF0F",
          }}
        ></div>
        <div
          style={{
            borderRadius: "20px 0px 20px 0px",
            width: 45,
            height: 40,
            borderWidth: "3px",
            borderStyle: "solid",
            borderColor: theme.COLORS.GREEN.green,
            marginTop: "-28vh",
            marginLeft: "620px",
            opacity: 0.25,
          }}
        />
      </div>
      <div style={{ marginLeft: "3vw", position: "absolute", top: "12rem" }}>
        <img
          className="mx-auto"
          style={{
            marginTop: "25vh",
            zIndex: 99,
            position: "relative",
            width: "38vw",
          }}
          src={mattress_photo}
        ></img>
      </div>
      <div style={{ marginLeft: "26vw", marginTop: "-40vh" }}>
        <img
          className="mx-auto"
          style={{
            marginTop: "1vh",
            zIndex: 99,
            position: "relative",
            width: "17vw",
          }}
          src={dots_green}
        ></img>
      </div>
      <div
        className="row"
        style={{
          backgroundColor: theme.COLORS.GREEN.green,
          width: 270,
          height: 150,
          textAlign: "center",
          borderRadius: 15,
          paddingTop: 10,
          zIndex: 99,
          position: "relative",
          marginLeft: "36.5vw",
          marginTop: "-15vh",
        }}
      >
        <p
          style={{
            fontSize: 19,
            color: "white",
            fontFamily: "noto-sans",
          }}
        >
          Only the best will do.
        </p>
        <p
          style={{
            fontSize: 17,
            color: "white",
            marginTop: -10,
            fontFamily: "noto-sans",
          }}
        >
          Two adjustable layers of 2” Talalay Latex. The best comfort material.
          Period.
        </p>
      </div>
    </div>
  );
};

export default BuildYourBedColumn2;
